import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { isEqual, isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { UserNote } from 'user/note/user-note';
import { UserNotesState, UserNotesStore } from 'user/note/user-note.store';
import { UserNoteRepositoryPort } from 'user/port/note/user-note-repository.port';

@Injectable()
export class UserNoteRepositoryAdapter
	extends QueryEntity<UserNotesState>
	implements UserNoteRepositoryPort
{
	constructor(protected store: UserNotesStore) {
		super(store);
	}

	public async deleteNoteById(noteId: string): Promise<void> {
		return this.store.remove(noteId);
	}

	public async persistUserNotes(entities: UserNote[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}

	public observeNotes(notesId: string[]): Observable<UserNote[]> {
		return this.selectMany(notesId).pipe(
			distinctUntilChanged(isEqual),
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
